import { render, staticRenderFns } from "./NoteP.vue?vue&type=template&id=0836dd89&scoped=true&"
import script from "./NoteP.vue?vue&type=script&lang=js&"
export * from "./NoteP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0836dd89",
  null
  
)

export default component.exports